import { memo } from 'react'

const ConditionalWrapper = ({ condition, wrapper, child }) => {
  return (condition ? wrapper(child()) : child())
}

export default memo(ConditionalWrapper)
